var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavedLinesBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 453,
    viewBox: "0 0 1440 453",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 166H823.349C879.418 166 934.105 150.48 979.865 121.579L1100.54 45.3992C1146.31 16.514 1200.99 1.00176 1257.05 1H1440",
    stroke: "#FF993A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 201H823.349C879.418 201 934.105 185.574 979.865 156.849L1100.54 81.1304C1146.31 52.4203 1200.99 37.0017 1257.05 37H1440",
    stroke: "#FF993A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 237H823.349C879.418 237 934.105 221.574 979.865 192.849L1100.54 117.13C1146.31 88.42 1200.99 73.0017 1257.05 73H1440",
    stroke: "#FF993A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 273H823.349C879.415 273.008 934.103 257.493 979.865 228.595L1100.54 152.405C1146.31 123.516 1200.99 108.002 1257.05 108H1440",
    stroke: "#FF993A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 309H823.349C879.413 308.998 934.098 293.484 979.865 264.595L1100.54 188.405C1146.31 159.516 1200.99 144.002 1257.05 144H1440",
    stroke: "#FF993A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 345H823.349C879.413 344.998 934.098 329.484 979.865 300.595L1100.54 224.405C1146.3 195.507 1200.99 179.992 1257.05 180H1440",
    stroke: "#FF993A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 380H823.349C879.413 379.998 934.098 364.58 979.865 335.87L1100.54 260.151C1146.3 231.426 1200.99 216 1257.05 216H1440",
    stroke: "#FF993A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 416H823.349C879.413 415.998 934.098 400.58 979.865 371.87L1100.54 296.151C1146.3 267.426 1200.99 252 1257.05 252H1440",
    stroke: "#FF993A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 452H823.349C879.413 451.998 934.098 436.486 979.865 407.601L1100.54 331.421C1146.3 302.52 1200.99 287 1257.05 287H1440",
    stroke: "#FF993A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavedLinesBackground);
export default __webpack_public_path__ + "static/media/waved-lines-background.acf02029d40fccf7723854459b755f5f.svg";
export { ForwardRef as ReactComponent };